var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBtVoltar = function SvgBtVoltar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36.5px",
    height: "36.5px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(103, 103, 120)",
    d: "M21.449,24.174 L19.964,25.659 L14.024,19.719 L14.024,19.719 L12.539,18.234 L14.024,16.749 L14.024,16.750 L19.964,10.810 L21.449,12.295 L15.509,18.234 L21.449,24.174 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "rgb(201, 201, 207)",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "none",
    d: "M18.000,0.500 C27.665,0.500 35.500,8.335 35.500,18.000 C35.500,27.665 27.665,35.500 18.000,35.500 C8.335,35.500 0.500,27.665 0.500,18.000 C0.500,8.335 8.335,0.500 18.000,0.500 Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBtVoltar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bt-voltar.407461f2.svg";
export { ForwardRef as ReactComponent };